import group_quality from "./quality_group";

export default {
  methods: {
    calculateSamplingOperationByGroup: function (quality_group, sampling_values) {
      // sampling_values format:
      // sampling_values = {
      //   quality_group_id: {
      //     quality_attribute_id: value
      //   }
      // }
      if (!quality_group.use_operation) return 0;
      let data = sampling_values[quality_group.id];
      delete data[quality_group.quality_attribute_id];
      data = Object.values(data);
      const calculated_value =
      group_quality.methods.operateData(data, quality_group);
      return calculated_value
    },
  }
}